import { reportConstants } from '../constants/report.constants';

export function report(state = {}, action) {
  switch (action.type) {
    case reportConstants.WORKJOURNEY_FETCH_REQUEST:
    case reportConstants.INTEGRATIONLOG_FETCH_REQUEST:
    case reportConstants.LASTCONTACT_FETCH_REQUEST:
    case reportConstants.NOTIFICATION_FETCH_REQUEST:
    case reportConstants.REPROCESS_REQUEST:
    case reportConstants.ACCESS_FETCH_REQUEST:
      return {
        ...state,
        loading: true
      };
    case reportConstants.WORKJOURNEY_FETCH_SUCCESS:
      return {
        ...state,
        workJourney: action.workJourneyRegisters,
        loading: false
      };
    case reportConstants.INTEGRATIONLOG_FETCH_SUCCESS:
      return {
        ...state,
        integrationLogs: action.integrationLogs,
        loading: false
      };
    case reportConstants.NOTIFICATION_FETCH_SUCCESS:
      return {
        ...state,
        notifications: action.notifications,
        loading: false
      };
    case reportConstants.REPROCESS_SUCCESS:
      return {
        ...state,
        workJourneyReprocess: action.clockReprocess,
        loading: false
      };
    case reportConstants.LASTCONTACT_FETCH_SUCCESS:
      return {
        ...state,
        lastContact: action.lastContactRegisters,
        loading: false
      };
    case reportConstants.ACCESS_FETCH_SUCCESS:
      return {
        ...state,
        access: action.accessRegisters,
        loading: false
      };
    case reportConstants.WORKJOURNEY_FETCH_FAILURE:
    case reportConstants.INTEGRATIONLOG_FETCH_FAILURE:
    case reportConstants.NOTIFICATION_FETCH_FAILURE:
    case reportConstants.REPROCESS_FAILURE:
    case reportConstants.LASTCONTACT_FETCH_FAILURE:
    case reportConstants.ACCESS_FETCH_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    default:
      return state
  }
}
